/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProcessingStatusType = {
    Waiting: 'Waiting',
    Started: 'Started',
    Transcribed: 'Transcribed',
    Embedded: 'Embedded',
    Ended: 'Ended',
    Interrupted: 'Interrupted'
} as const;
export type ProcessingStatusType = typeof ProcessingStatusType[keyof typeof ProcessingStatusType];


export function ProcessingStatusTypeFromJSON(json: any): ProcessingStatusType {
    return ProcessingStatusTypeFromJSONTyped(json, false);
}

export function ProcessingStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessingStatusType {
    return json as ProcessingStatusType;
}

export function ProcessingStatusTypeToJSON(value?: ProcessingStatusType | null): any {
    return value as any;
}

